let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3sraF")).then(() => parcelRequire('bq6BP'));